<template>
    <el-form class="well" ref="form" :model="form" label-width="150" label-position="left">
        <article>
            <h3 class="mt-0">{{ $l10n.__('Documents de vente') }}</h3>
            <p>
                {{
                    $l10n.__(
                        'Choisissez à partir de quelle étape vous voulez que vos documents de vente soient envoyés automatiquement en compta',
                    )
                }}
            </p>
            <el-form-item class="mb-0">
                <template #label>
                    <span class="gray-100">{{ getStepById('invoice').label }}</span>
                </template>
                <el-select
                    v-model="form.autoinvoiceStatus"
                    :placeholder="$t.__('common.actions.select')"
                >
                    <el-option
                        v-for="item in getStepById('invoice').steps"
                        :key="item.id"
                        :label="item.label"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <template #label>
                    <span class="gray-100">{{ getStepById('creditnote').label }}</span></template
                >
                <el-select
                    v-model="form.autocreditnoteStatus"
                    :placeholder="$t.__('common.actions.select')"
                >
                    <el-option
                        v-for="item in getStepById('creditnote').steps"
                        :key="item.id"
                        :label="item.label"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
        </article>

        <article>
            <h3>{{ $l10n.__("Documents d'achat") }}</h3>
            <p>
                {{
                    $l10n.__(
                        "Choisissez à partir de quelle étape vous voulez que vos documents d'achat soient envoyés automatiquement en compta",
                    )
                }}
            </p>
            <el-form-item>
                <template #label
                    ><span class="gray-100">{{ getStepById('purInvoice').label }}</span></template
                >
                <el-select
                    v-model="form.autopurinvoiceStatus"
                    :placeholder="$t.__('common.actions.select')"
                >
                    <el-option
                        v-for="item in getStepById('purInvoice').steps"
                        :key="item.id"
                        :label="item.label"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <template #label>
                    <span class="gray-100">{{ getStepById('purCreditNote').label }}</span></template
                >
                <el-select
                    v-model="form.autopurcreditnoteStatus"
                    :placeholder="$t.__('common.actions.select')"
                >
                    <el-option
                        v-for="item in getStepById('purCreditNote').steps"
                        :key="item.id"
                        :label="item.label"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
        </article>
        <div class="flex-level">
            <CompassButton
                :label="$t.__('common.actions.save')"
                type="primary"
                @click="submit"
                class="flex-item-right"
            />
        </div>
    </el-form>
</template>

<script>
import AccountingService from 'api/accounting';
export default {
    props: {
        steps: {
            type: String,
            required: true,
        },
        accountingprefs: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            decodedSteps: null,
            decodedPrefs: null,
            form: {
                autoinvoiceStatus: '',
                autocreditnoteStatus: '',
                autopurinvoiceStatus: '',
                autopurcreditnoteStatus: '',
            },
        };
    },
    created() {
        this.decodedSteps = JSON.parse(this.steps);
        this.decodedPrefs = JSON.parse(this.accountingprefs);
        this.form = {
            autoinvoiceStatus: this.decodedPrefs.autoinvoiceStatus,
            autocreditnoteStatus: this.decodedPrefs.autocreditnoteStatus,
            autopurinvoiceStatus: this.decodedPrefs.autopurinvoiceStatus,
            autopurcreditnoteStatus: this.decodedPrefs.autopurcreditnoteStatus,
        };
    },

    methods: {
        getStepById(id) {
            const step = this.decodedSteps.find((step) => step.syscode === id);

            delete step.steps._xml_childtag;
            return step;
        },
        submit() {
            AccountingService.setAutomaticAccountingRecordPrefs(this.form, this.decodedPrefs.id)
                .then(() => {
                    location.reload();
                })
                .catch((err) => {
                    this.errorsHandler.logException(err);
                    Push.error(
                        this.$l10n.__(
                            'Une erreur est survenue. Veuillez réessayez ultérieurement.',
                        ),
                    );
                });
        },
    },
};
</script>
